import DeviceCollection from './DeviceCollection';

class IncompleteDeviceCollection extends DeviceCollection {
  get url() {
    return '/api/ui/devices/incomplete';
  }
}

export default IncompleteDeviceCollection;
